<template>
  <DetailTemplate
    :customClass="'service-detail detail-page'"
    v-if="getPermission('service:view')"
  >
    <template v-slot:sidebar-detail>
      <v-card class="h-100" elevation="0">
        <div class="d-flex px-0 py-3">
          <!-- <v-btn v-on:click="goBack" icon plain>
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <v-spacer></v-spacer> -->
          <div>
            <v-chip
              v-if="detail.activated == 1"
              class="mx-2"
              color="#66bb6a"
              label
              text-color="white"
            >
              Active
            </v-chip>
            <v-chip
              v-if="detail.name === '1st Free Service after Installation'"
              class="font-weight-bold mx-2"
              color="orange darken-4"
              label
              text-color="white"
            >
              Default Service
            </v-chip>
            <v-chip
              v-if="detail.activated == 0"
              class="mx-2"
              color="red"
              text-color="white"
              label
            >
              In-Active
            </v-chip>
          </div>
        </div>
        <div class="px-2 py-5 text-center">
          <ImageNew
            :images="detail.product_images"
            :parent="detail.id"
            type="service"
            :isPageLoading="pageLoading"
          ></ImageNew>
        </div>
        <div class="pt-0">
          <table class="width-100">
            <tr>
              <th
                colspan="2"
                class="grey lighten-4 font-size-16 text-uppercase color-custom-blue py-2 px-3 mb-2"
              >
                Basic Information
              </th>
            </tr>
            <tr>
              <td
                class="font-size-18 font-weight-500 py-1 border-bottom-dashed"
                width="140"
              >
                Service #
              </td>
              <td class="font-size-18 py-1 border-bottom-dashed">
                <span v-if="detail && detail.barcode">
                  <v-chip
                    small
                    label
                    color="chip-custom-blue"
                    outlined
                    class="text-white font-weight-600"
                    >{{ detail.barcode }}</v-chip
                  >
                </span>
                <em v-else class="text-muted"> no item code </em>
              </td>
            </tr>
            <tr>
              <td
                class="font-size-18 font-weight-500 py-1 border-bottom-dashed"
              >
                Service No.
              </td>
              <td class="font-size-18 py-1 border-bottom-dashed">
                <span
                  v-if="detail?.product_prefix || detail?.product_prefix_no"
                >
                  <v-chip
                    small
                    label
                    color="blue"
                    outlined
                    class="text-white text-capitalize font-weight-600"
                    >{{ detail?.product_prefix }}-{{
                      detail?.product_prefix_no
                    }}</v-chip
                  >
                  <showBarcode
                    v-if="false"
                    :barcodeUrl="detail.serial_image"
                    :barcode-text="detail.serial_no"
                    title="Barcode"
                  />
                </span>
                <em v-else class="text-muted"> no service no </em>
              </td>
            </tr>
            <tr>
              <td
                class="font-size-18 font-weight-500 py-1 border-bottom-dashed"
              >
                Brand
              </td>
              <td class="font-size-18 py-1 border-bottom-dashed">
                <span v-if="detail && detail.brand">
                  <v-chip
                    small
                    outlined
                    label
                    color="blue"
                    class="font-weight-600"
                  >
                    {{ detail.brand }}
                  </v-chip>
                </span>
                <em v-else class="text-muted"> no brand </em>
              </td>
            </tr>
            <tr>
              <td class="font-size-18 font-weight-500 py-1">Category</td>
              <td class="font-size-18 py-1">
                <span v-if="detail && detail.category">
                  <v-chip
                    small
                    outlined
                    label
                    color="blue"
                    class="font-weight-600"
                  >
                    {{ detail.category }}
                  </v-chip>
                </span>
                <em v-else class="text-muted"> no category </em>
              </td>
            </tr>

            <!-- <tr>
              <td class="font-size-18 font-weight-500 py-1">Reference no.</td>
              <td class="font-size-18 py-2">
                <span v-if="detail && detail.ref_number">
                  <v-chip outlined label small color="blue">
                    {{ detail.ref_number }}
                  </v-chip>
                </span>
                <em v-else class="text-muted"> no Reference no. </em>
              </td>
            </tr>
            <tr>
              <td class="font-size-18 font-weight-500 py-1">
                Internal Service no.
              </td>
              <td class="font-size-18 py-1">
                <span v-if="detail && detail.int_service_number">
                  <v-chip outlined label small color="blue">
                    {{ detail.int_service_number }}
                  </v-chip>
                </span>
                <em v-else class="text-muted">no Internal Service</em>
              </td>
            </tr> -->
          </table>
          <table class="mt-4" width="100%">
            <tr>
              <th
                colspan="2"
                class="grey lighten-4 font-size-16 text-uppercase color-custom-blue py-2 px-3 mb-2"
              >
                Price Information
              </th>
            </tr>
            <!--  <tr>
              <td class="font-size-18 font-weight-500 py-1" width="150">
                Unit Price(Selling)
              </td>
              <td class="font-size-18 py-1">
                <template v-if="dataLoading">
                  <v-skeleton-loader class="custom-skeleton" type="text">
                  </v-skeleton-loader>
                </template>
                <template v-else>
                  <template v-if="dataLoading">
                    <v-skeleton-loader class="custom-skeleton" type="text">
                    </v-skeleton-loader>
                  </template>
                  <template v-else>
                    {{ $accountingJS.formatMoney(detail.charges) }}
                  </template>
                </template>
              </td>
            </tr>
            <tr>
              <td class="font-size-18 font-weight-500 py-1">Start Date</td>
              <td class="font-size-18 py-1">
                <span v-if="detail && detail.start_date">
                  {{ detail.start_date }}</span
                >
                <em v-else class="text-muted"> no start date</em>
              </td>
            </tr>
            <tr>
              <td class="font-size-18 font-weight-500 py-1">End Date</td>
              <td class="font-size-18 py-1">
                <span v-if="detail && detail.end_date">
                  {{ detail.end_date }}</span
                >
                <em v-else class="text-muted"> no end date</em>
              </td>
            </tr>
            <tr>
              <td colspan="2"><v-divider></v-divider></td>
            </tr> -->
            <tr v-if="false">
              <td class="font-size-18 font-weight-500 py-1">Tax Name</td>
              <td class="font-size-18 py-1">
                <span v-if="detail && detail.tax_name" class="text-capitalize">
                  {{ detail.tax_name }}</span
                >
                <em v-else class="text-muted"> no tax name</em>
              </td>
            </tr>
            <tr v-if="false">
              <td class="font-size-18 font-weight-500 py-1">Tax Rate (%)</td>
              <td class="font-size-18 py-1">
                <span v-if="detail && detail.tax_rate">
                  {{ detail.tax_rate }}</span
                >
                <em v-else class="text-muted"> no tax rate</em>
              </td>
            </tr>
            <!--   <tr>
              <td class="font-size-18 font-weight-500 py-1">Purchase date</td>
              <td class="font-size-18 py-1">
                <span v-if="detail && detail.purchase_date_formatted">
                  {{ detail.purchase_date_formatted }}</span
                >
                <em v-else class="text-muted"> no purchase date</em>
              </td>
            </tr> -->
            <!-- <tr>
              <td class="font-size-18 font-weight-700 py-1">Cost(Purchase)</td>
              <td class="font-weight-600 font-size-18 py-2">
                <span v-if="detail && detail.cost"> {{ detail.cost }}</span>
                <em v-else class="text-muted"> no Cost</em>
              </td>
            </tr> -->
            <tr>
              <template v-if="detail.product_type == 'service'">
                <td class="font-size-18 font-weight-500 py-1" width="140">
                  UOM
                </td>
                <td class="font-size-18 py-1">
                  <span v-if="detail && detail.unit"> {{ detail.unit }}</span>
                  <em v-else class="text-muted"> no UOM</em>
                </td>
              </template>
            </tr>
          </table>
        </div>
      </v-card>
    </template>
    <template v-slot:header-title>
      <div class="d-flex">
        <template v-if="pageLoading">
          <v-skeleton-loader
            class="custom-skeleton height-40px custom-skeleton-full-width"
            width="600"
            type="text"
          >
          </v-skeleton-loader>
        </template>
        <template v-else>
          <v-tooltip
            max-width="600"
            bottom
            content-class="custom-bottom-tooltip"
            :disabled="!detail.name"
          >
            <template v-slot:activator="{ on, attrs }">
              <h1
                v-bind="attrs"
                v-on="on"
                class="form-title custom-nowrap-ellipsis text-capitalize mb-0 mr-2"
              >
                {{ detail.name }}
              </h1>
            </template>
            <span>{{ detail.name }}</span>
          </v-tooltip>
          <!-- <v-chip
            label
            color="chip-custom-blue"
            outlined
            class="text-white p-3"
            style="font-size: 21px !important; font-weight: 700"
            >{{ detail.barcode }}</v-chip
          >
          <v-chip
            v-if="detail.activated == 1"
            class="mx-2"
            color="#66bb6a"
            label
            outlined
            text-color="green"
          >
            Active
          </v-chip>
          <v-chip
            v-if="detail.activated == 0"
            class="mx-2"
            color="red"
            outlined
            text-color="red"
            label
          >
            In-Active
          </v-chip> -->
        </template>
      </div>
    </template>
    <template v-slot:header-action>
      <template v-if="getPermission('service:update')">
        <v-skeleton-loader
          class="custom-skeleton d-inline-block"
          v-if="pageLoading"
          type="button"
        >
        </v-skeleton-loader>
        <v-menu
          v-else
          transition="slide-y-transition"
          bottom
          content-class="custom-menu-list"
          offset-y
        >
          <template
            v-slot:activator="{ on, attrs }"
            v-if="detail.name !== '1st Free Service after Installation'"
          >
            <v-btn
              :disabled="!formValid || formLoading || pageLoading"
              :loading="formLoading"
              class="mx-2 custom-bold-button white--text"
              color="cyan"
              depressed
              v-bind="attrs"
              v-on="on"
            >
              More... <v-icon right>mdi-chevron-down</v-icon>
            </v-btn>
          </template>
          <v-list>
            <template v-for="(more, index) in serviceMoreAction">
              <v-list-item
                link
                v-on:click="updateMoreAction(more.action)"
                :key="index"
                :disabled="more.disabled"
              >
                <v-list-item-icon class="margin-auto-zero mr-3 my-2">
                  <v-icon class="icon-default-blue">{{ more.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-title class="font-weight-500 font-size-14">{{
                  more.title
                }}</v-list-item-title>
              </v-list-item>
            </template>
          </v-list>
        </v-menu>
      </template>
      <template v-if="getPermission('service:update')">
        <v-btn
          class="mx-2 custom-bold-button white--text"
          color="cyan"
          depressed
          :to="
            getDefaultRoute('service.update', {
              param: { id: service },
            })
          "
        >
          <v-icon size="20">mdi-pencil</v-icon>
        </v-btn>
      </template>
      <v-btn
        class="mx-2 custom-grey-border custom-bold-button"
        depressed
        v-on:click="goBack"
      >
        <v-icon small left>mdi-keyboard-backspace</v-icon>
        Back
      </v-btn>
    </template>
    <template v-slot:body>
      <v-container fluid class="px-0 pt-0">
        <v-tabs
          v-model="serviceTab"
          background-color="transparent"
          color="cyan"
          class="custom-tab-transparent"
        >
          <template v-for="(tab, index) in tabs">
            <v-tab
              v-if="getPermission(tab.permission + ':view')"
              class="font-size-16 font-weight-600 px-8"
              :key="index"
              :href="'#' + tab.key"
              :disabled="tab.disabled"
            >
              <span class="svg-icon svg-icon-lg mr-4 svg-v-list-icon">
                <!--begin::Svg Icon-->
                <inline-svg
                  :src="$assetURL('media/custom-svg/' + tab.key + '.svg')"
                />
                <!--end::Svg Icon-->
              </span>
              {{ tab.title }}
              <span v-if="tab.title == 'Pricing'">
                ({{
                  detail.product_pricelogs
                    ? detail.product_pricelogs.length
                    : 0
                }})
              </span>
            </v-tab>
          </template>
        </v-tabs>
        <v-card class="mt-0 pb-4" elevation="0">
          <v-tabs-items v-model="serviceTab">
            <v-tab-item
              v-if="getPermission('service:view')"
              :value="'overview'"
            >
              <Overview :detail="detail"></Overview>
            </v-tab-item>
            <v-tab-item v-if="getPermission('service:view')" value="pricing">
              <ProductPriceListing
                type="pricing"
                :price-data="detail.product_pricelogs"
                :product="detail.id"
                @success="getProductDetail()"
              ></ProductPriceListing>
            </v-tab-item>
            <v-tab-item v-if="getPermission('service:view')" :value="'image'">
              <div class="service-detail-height">
                <Images
                  :images="detail.product_images"
                  :parent="detail.id"
                  type="service"
                  :isPageLoading="pageLoading"
                ></Images>
              </div>
            </v-tab-item>

            <v-tab-item v-if="getPermission('job:view')" :value="'job'">
              <div class="service-detail-search-height">
                <Tickets :detail="detail" type="service"></Tickets>
              </div>
            </v-tab-item>
            <v-tab-item
              v-if="getPermission('quotation:view')"
              :value="'quotation'"
            >
              <div class="service-detail-search-height">
                <Quotations :detail="detail" type="service"></Quotations>
              </div>
            </v-tab-item>
            <v-tab-item
              v-if="getPermission('product:view')"
              :value="'customer'"
            >
              <v-row no-gutters>
                <v-col cols="6" class="margin-auto">
                  <h2 class="margin-auto color-custom-blue font-weight-600">
                    Customers
                  </h2>
                </v-col>
                <v-col cols="6">
                  <span>
                    <template>
                      <span class="float-right">
                        <v-skeleton-loader
                          class="custom-skeleton d-inline-block custom-skeleton-full-width"
                          v-if="pageLoading"
                          type="button"
                          height="28"
                          width="200"
                        >
                        </v-skeleton-loader>
                        <template v-else>
                          <v-btn
                            depressed
                            class="mx-2 custom-bold-button white--text"
                            color="cyan"
                            small
                            v-on:click="onAddClick()"
                          >
                            <v-icon dark left>mdi-plus</v-icon>Add CUSTOMER
                          </v-btn>
                        </template>
                      </span>
                    </template>
                  </span>
                </v-col>
              </v-row>
              <v-col>
                <CustomerDetail
                  :customers="detail.customers_sors_service || []"
                  :pageLoading="pageLoading"
                  source="service"
                  @edit-product="onEditCustomer"
                  @refresh="getProductDetail()"
                ></CustomerDetail>
              </v-col>
            </v-tab-item>
            <v-tab-item v-if="getPermission('invoice:view')" :value="'invoice'">
              <div class="service-detail-search-height">
                <Invoices :detail="detail" type="service"></Invoices>
              </div>
            </v-tab-item>
            <v-tab-item :value="'service-quotation'">
              <div>
                <ProductsQuotation
                  :detail="detail"
                  type="service"
                ></ProductsQuotation>
              </div>
            </v-tab-item>
            <v-tab-item v-if="getPermission('history:view')" :value="'history'">
              <div class="service-detail-search-height">
                <InternalHistoryDetail
                  type="service"
                  :type_id="detail.id"
                ></InternalHistoryDetail>
              </div>
            </v-tab-item>

            <v-tab-item value="attachment">
              <AdditionalDocuments
                :type-id="detail.id"
                class="mx-4"
                type-text="Service Documents"
                :type="10"
                :extensive="false"
              ></AdditionalDocuments>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-container>
      <Dialog :common-dialog="customerDialog" :dialog-width="600">
        <template v-slot:title>
          {{ customerForm.id ? "Update Customer" : "Add Customer" }}
        </template>

        <template v-slot:body>
          <v-form ref="productFormRef" v-model="customerValid">
            <v-container>
              <!-- Product Select -->
              <label class="my-auto fw-500 required mb-1">Customer</label>
              <v-select
                v-model="customerForm.customer"
                :items="filteredCustomerList"
                item-text="display_name"
                item-value="id"
                item-color="cyan"
                item-disabled="disabled"
                dense
                flat
                solo
                filled
                placeholder="Select Customer"
                :rules="[
                  validateRules.required(customerForm.customer, 'Customer'),
                ]"
              />

              <!-- Price -->
              <label class="my-auto fw-500 required mb-1">Price</label>
              <PriceField
                v-model="customerForm.price"
                type="text"
                inputmode="decimal"
                dense
                flat
                solo
                filled
                placeholder="Enter Price"
                :rules="[
                  validateRules.required(customerForm.price, 'Price'),
                ]"
                @input="isManualPriceChange = true"
              />
            </v-container>
          </v-form>
        </template>

        <template v-slot:action>
          <v-btn
            color="cyan"
            class="white--text"
            :disabled="!customerValid"
            :loading="customerLoading"
            @click="submitCustomer"
          >
            {{ customerForm.id ? "Update" : "Save" }}
          </v-btn>

          <v-btn @click="closeCustomerDialog"> Cancel </v-btn>
        </template>
      </Dialog>
    </template>
  </DetailTemplate>
</template>

<script>
import DetailTemplate from "@/view/pages/partials/Detail-Template.vue";
import CommonMixin from "@/core/plugins/common-mixin";
import CustomerDetail from "@/view/pages/product/detail/Customer-Detail";

import { GET, PATCH, QUERY } from "@/core/services/store/request.module";
import Overview from "@/view/pages/service/detail/Overview";
import Tickets from "@/view/pages/partials/Detail/Tickets";
import Quotations from "@/view/pages/partials/Detail/Quotation";
import Invoices from "@/view/pages/partials/Detail/Invoice";
import ImageNew from "@/view/pages/partials/Detail/ImageNew";
import Images from "@/view/pages/partials/Detail/Image";
import InternalHistoryDetail from "@/view/pages/partials/Detail/Internal-History-Detail.vue";
import AdditionalDocuments from "@/view/pages/engineer/Additional-Documents";
import showBarcode from "@/view/components/showBarcode.vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { SET_ACTIVE_FIELD_DATA } from "@/core/services/store/custom.fields.module.js";
import ProductPriceListing from "@/view/pages/product/detail/ProductPriceListing";
import Dialog from "@/view/pages/partials/Dialog.vue";
import ValidationMixin from "@/core/plugins/validation-mixin";
import ProductsQuotation from "@/view/pages/partials/Detail/Products-Quotation";

export default {
  mixins: [CommonMixin, ValidationMixin],
  data() {
    return {
      dataLoading: null,
      detail: new Object(),
      // serviceTab: "service",
      serviceMoreAction: [
        /*  {
          title: "Duplicate",
          action: "duplicate",
          icon: "mdi-content-duplicate",
          disabled: false,
        }, */
        {
          title: "Mark as Active",
          action: "mark_as_active",
          icon: "mdi-check-all",
          disabled: false,
        },
        {
          title: "Mark as In-Active",
          action: "mark_as_inactive",
          icon: "mdi-check-all",
          disabled: false,
        },
      ],
      tabs: [
        {
          title: "Overview",
          icon: "mdi-phone",
          key: "overview",
          permission: "service",
          disabled: false,
        },
        {
          title: "Pricing",
          icon: "mdi-phone",
          key: "pricing",
          permission: "product",
          disabled: false,
        },
        /*     {
          title: "Images",
          icon: "mdi-phone",
          key: "image",
          permission: "product",
          disabled: false,
        }, */
        {
          title: "Customer SOR",
          icon: "mdi-phone",
          key: "customer",
          permission: "product",
          disabled: false,
        },
        {
          title: "Service Quotations",
          icon: "mdi-account-multiple",
          key: "service-quotation",
          permission: "quotation",
          disabled: false,
        },
        {
          title: "Attachments",
          icon: "mdi-account-multiple",
          key: "attachment",
          permission: "product",
          disabled: false,
        },
        /*{
          title: "Jobs",
          icon: "mdi-credit-card",
          key: "job",
          permission: "job",
          disabled: false,
        },
        {
          title: "Quotations",
          icon: "mdi-account-multiple",
          key: "quotation",
          permission: "quotation",
          disabled: false,
        },
        {
          title: "Invoices",
          icon: "mdi-account-multiple",
          key: "invoice",
          permission: "invoice",
          disabled: false,
        },*/
        {
          title: "History",
          icon: "mdi-account-multiple",
          key: "history",
          permission: "history",
          disabled: false,
        },
      ],
      formValid: true,
      formLoading: false,
      pageLoading: false,
      isManualPriceChange: false,
      customerLoading: false,
      customerDialog: false,
      customerValid: false,
      customerList: [],
      customerForm: {
        customer: null,
        price: 0,
      },
      service: 0,
    };
  },
  components: {
    DetailTemplate,
    ImageNew,
    Dialog,
    Images,
    Overview,
    Tickets,
    Quotations,
    Invoices,
    InternalHistoryDetail,
    AdditionalDocuments,
    ProductPriceListing,
    showBarcode,
    CustomerDetail,
    ProductsQuotation,
  },
  methods: {
    closeCustomerDialog() {
      this.customerDialog = false;
      this.customerForm = {
        customer: null,
        price: null,
      };
    },
    submitCustomer() {
      const _this = this;

      if (!_this.$refs.productFormRef.validate()) return;

      _this.customerLoading = true;

      const payload = {
        id: this.customerForm.id || null,
        customer: _this.customerForm.customer,
        parent: _this.detail.id,
        price: _this.customerForm.price,
        source: "service",
        type: 1,
      };

      _this.$store
        .dispatch(PATCH, {
          url: "customer-sor",
          data: payload,
        })
        .then(() => {
          _this.customerLoading = false;

          _this.closeCustomerDialog();
          _this.getProductDetail();
        })
        .catch((error) => {
          _this.customerLoading = false;
          _this.logError(error);
        });
    },
    onEditCustomer(item) {
      this.customerDialog = true;

      this.customerForm = {
        id: item.id,
        customer: Number(item.customer),
        price: item.price,
      };
    },
    onAddClick() {
      this.customerForm = {
        customer: null,
        price: Number(this.detail.sale_price),
      };

      this.isManualPriceChange = false;
      this.customerDialog = true;
    },
    getCustomerList() {
      this.$store
        .dispatch(QUERY, {
          url: "customer-list",
          data: { search: this.search },
        })
        .then(({ data }) => {
          this.customerList = data;
        })
        .catch((error) => {
          this.logError(error);
        });
    },
    patchProductParams(status) {
      const _this = this;
      _this.pageLoading = true;
      _this.$store
        .dispatch(PATCH, {
          url: "product",
          data: {
            status,
            products: [_this.service],
          },
        })
        .then(() => {
          _this.getProductDetail();
        })
        .catch((error) => {
          _this.logError(error);
        });
    },
    updateMoreAction(action) {
      const _this = this;
      switch (action) {
        case "duplicate":
          _this.duplicateProduct();
          break;
        case "mark_as_active":
          _this.patchProductParams(1);
          break;
        case "mark_as_inactive":
          _this.patchProductParams(0);
          break;
      }
    },
    duplicateProduct() {
      this.$router.push(
        this.getDefaultRoute("service.create", {
          query: {
            duplicate: this.service,
          },
        })
      );
    },
    // goBack() {
    //   this.$router.push("/admin/service");
    // },
    getProductDetail() {
      const _this = this;
      _this.pageLoading = true;
      _this.$store
        .dispatch(GET, {
          url: "service/" + _this.service,
        })
        .then(({ data }) => {
          _this.detail = data;
          if (Array.isArray(this.detail.custom_fields_service)) {
            this.$store.commit(
              SET_ACTIVE_FIELD_DATA,
              this.detail.custom_fields_service
            );
          }
          _this.$store.dispatch(SET_BREADCRUMB, [
            { title: "Service", route: "service" },
            { title: "Detail" },
            { barcode: data.barcode },
          ]);
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },
  },
  mounted() {
    const _this = this;
    _this.getProductDetail();
    _this.getCustomerList();
    // this.serviceTab = "service";
    _this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Service", route: "service" },
      { title: "Detail" },
    ]);
  },
  created() {
    const _this = this;
    _this.service = _this.$route.params.id;
    if (!_this.service || _this.service <= 0) {
      _this.$router.go(-1);
    }

    // if (_this.$route.query && _this.$route.query.tab) {
    //   _this.serviceTab = _this.$route.query.tab;
    // }
  },

  // computed: {
  //   serviceTab: {
  //     set(val) {
  //       let query = { ...this.$route.query };
  //       query.tab = val;
  //       if (this.serviceTab != val) {
  //         this.$router.push({ query });
  //       }
  //     },
  //     get() {
  //       return this.$route.query.tab || "service";
  //     },
  //   },
  //   // },
  // beforeDestroy() {
  // 	this.$store.dispatch(SET_BREADCRUMB, []);
  // },
  computed: {
    serviceTab: {
      get() {
        return this.$route.query.tab || "overview";
      },
      set(val) {
        const current = this.$route.query.tab || "overview";
        if (val === current) return; // 🔐 critical

        const query = { ...this.$route.query };

        if (val === "overview") {
          delete query.tab;
        } else {
          query.tab = val;
        }

        this.$router.push({ query });
      },
    },
    filteredCustomerList() {
      const addedCustomerIds =
        this.detail?.customers_sors_service?.map((customer) =>
          Number(customer.customer)
        ) || [];

      return this.customerList.map((customer) => ({
        ...customer,
        disabled:
          addedCustomerIds.includes(Number(customer.id)) &&
          Number(customer.id) !== Number(this.customerForm.customer),
      }));
    },
  },
};
</script>

<style>
#attachment .overflow-y {
  max-height: none !important;
}
</style>
